import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuditProvider } from "@/components/AuditContext";
import { Layout } from "@/components/Layout";
import { AnalyticsListener } from "@/components/AnalyticsListener";
import Home from "@/pages/Home";
import Offres from "@/pages/Offres";
import CeQueVousObtenez from "@/pages/CeQueVousObtenez";
import Pourquoi from "@/pages/Pourquoi";
import Contact from "@/pages/Contact";
import Merci from "@/pages/Merci";
import Promo from "@/pages/Promo";
import Partenaires from "@/pages/Partenaires";
import Mentions from "@/pages/Mentions";
import Confidentialite from "@/pages/Confidentialite";
import ServicePage from "@/pages/ServicePage";
import MetierPage from "@/pages/MetierPage";
import GuideIndex from "@/pages/GuideIndex";
import GuideArticle from "@/pages/GuideArticle";
import ActualitesIndex from "@/pages/ActualitesIndex";
import ActualitesArticle from "@/pages/ActualitesArticle";
import { SERVICE_ORDER } from "@/lib/servicesData";
import { METIER_ORDER } from "@/lib/metiersData";
import { LOCAL_ORDER } from "@/lib/localData";
import { GUIDE_ORDER } from "@/lib/guideData";
import { ACTU_ORDER } from "@/lib/actualitesData";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsListener />
        <AuditProvider>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/offres" element={<Offres />} />
              <Route path="/ce-que-vous-obtenez" element={<CeQueVousObtenez />} />
              <Route path="/promo" element={<Promo />} />
              {/* Service pages — each accepts an optional second-level (ville)
                  for future local pages. Local URLs currently redirect to the
                  base page (no auto-generated duplicate content). */}
              {SERVICE_ORDER.map((slug) => (
                <Route key={slug} path={`/${slug}`}>
                  <Route index element={<ServicePage slug={slug} />} />
                  <Route path=":ville" element={<ServicePage slug={slug} />} />
                </Route>
              ))}
              {/* Pages métier — une page par profession cible. */}
              {METIER_ORDER.map((slug) => (
                <Route key={slug} path={`/${slug}`} element={<MetierPage slug={slug} />} />
              ))}
              {/* Pages locales service + ville (dépannage, maintenance à Lille). */}
              {LOCAL_ORDER.map((slug) => (
                <Route key={slug} path={`/${slug}`} element={<MetierPage slug={slug} />} />
              ))}
              <Route path="/pourquoi-umbo-cyber" element={<Pourquoi />} />
              {/* Guide — educational articles, one page per topic. */}
              <Route path="/guide" element={<GuideIndex />} />
              {GUIDE_ORDER.map((slug) => (
                <Route key={slug} path={`/guide/${slug}`} element={<GuideArticle slug={slug} />} />
              ))}
              {/* Actualités — articles datés (fraîcheur SEO). */}
              <Route path="/actualites" element={<ActualitesIndex />} />
              {ACTU_ORDER.map((slug) => (
                <Route key={slug} path={`/actualites/${slug}`} element={<ActualitesArticle slug={slug} />} />
              ))}
              <Route path="/partenaires" element={<Partenaires />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/merci" element={<Merci />} />
              <Route path="/mentions-legales" element={<Mentions />} />
              <Route path="/politique-de-confidentialite" element={<Confidentialite />} />
              {/* Redirections des anciennes URL */}
              <Route path="/pourquoi-nous" element={<Navigate to="/pourquoi-umbo-cyber" replace />} />
              <Route path="/confidentialite" element={<Navigate to="/politique-de-confidentialite" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </AuditProvider>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}
export default App;
